"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormModelField = exports.FormModelMutatorField = void 0;
const core_api_1 = require("@ikegps/core-api");
const array_1 = require("../../util/array");
const form_field_lock_1 = require("./form.field.lock");
class FormModelMutatorField {
    constructor(field) {
        this.field = field;
    }
    get state() {
        return this.field.getForm().state;
    }
    displayName(displayName) {
        this.state.setFieldValue(this.field.fieldId, Object.assign(Object.assign({}, this.field.stateValue), { displayName }));
    }
    title(title) {
        var _a, _b;
        this.state.setFieldValue(this.field.fieldId, Object.assign(Object.assign({}, this.field.stateValue), { title }));
        // Unset other titles if this is the new title
        // Unset the subtitle if this is the new title
        if (title === true) {
            for (const field of (_b = (_a = this.field.parent) === null || _a === void 0 ? void 0 : _a.fields) !== null && _b !== void 0 ? _b : []) {
                if (field.title && field.id !== this.field.id) {
                    field.Mutator.title(false);
                }
                if (field.subtitle && field.id === this.field.id) {
                    field.Mutator.subtitle(false);
                }
            }
        }
    }
    subtitle(subtitle) {
        var _a, _b;
        this.state.setFieldValue(this.field.fieldId, Object.assign(Object.assign({}, this.field.stateValue), { subtitle }));
        // Unset other subtitles if this is the new subtitle
        // Unset the title if this is the new subtitle
        if (subtitle === true) {
            for (const field of (_b = (_a = this.field.parent) === null || _a === void 0 ? void 0 : _a.fields) !== null && _b !== void 0 ? _b : []) {
                if (field.subtitle && field.id !== this.field.id) {
                    field.Mutator.subtitle(false);
                }
                if (field.title && field.id === this.field.id) {
                    field.Mutator.title(false);
                }
            }
        }
    }
    isStatusField(useAsStatus) {
        var _a;
        this.state.setFieldValue(this.field.fieldId, Object.assign(Object.assign({}, this.field.stateValue), { isStatusField: useAsStatus }));
        if (useAsStatus) {
            this.field.getForm().metadata.setStatusField(this.field);
            (_a = this.field.parent) === null || _a === void 0 ? void 0 : _a.fields.forEach((field) => {
                if (field.isStatusField && field.id !== this.field.id) {
                    field.Mutator.isStatusField(false);
                }
            });
        }
        else {
            this.field.getForm().metadata.removeStatusField(this.field);
        }
    }
    isMapColorField(useAsMapColorField) {
        var _a;
        this.state.setFieldValue(this.field.fieldId, Object.assign(Object.assign({}, this.field.stateValue), { isMapColorField: useAsMapColorField }));
        if (useAsMapColorField) {
            this.field.getForm().metadata.setMapColorField(this.field);
            (_a = this.field.parent) === null || _a === void 0 ? void 0 : _a.fields.forEach((field) => {
                if (field.isMapColorField && field.id !== this.field.id) {
                    field.Mutator.isMapColorField(false);
                }
            });
        }
        else {
            this.field.getForm().metadata.removeMapColorField(this.field);
        }
    }
    annotationLabelFieldId(annotationLabelFieldId) {
        if (this.field.type === core_api_1.IkeFieldType.HEIGHT || this.field.type === core_api_1.IkeFieldType.VERTICAL_SEPARATION) {
            this.state.setFieldValue(this.field.fieldId, Object.assign(Object.assign({}, this.field.stateValue), { annotationLabelFieldId }));
        }
    }
    clearanceThresholdInMeters(clearanceThresholdInMeters) {
        if (this.field.type === core_api_1.IkeFieldType.VERTICAL_SEPARATION) {
            this.state.setFieldValue(this.field.fieldId, Object.assign(Object.assign({}, this.field.stateValue), { clearanceThresholdInMeters }));
        }
    }
    required(required) {
        this.state.setFieldValue(this.field.fieldId, Object.assign(Object.assign({}, this.field.stateValue), { required }));
    }
    isAddressLookupField(isAddress) {
        var _a;
        this.state.setFieldValue(this.field.fieldId, Object.assign(Object.assign({}, this.field.stateValue), { isAddressLookupField: isAddress }));
        if (isAddress) {
            this.field.getForm().metadata.setAddressLookupField(this.field);
            (_a = this.field.parent) === null || _a === void 0 ? void 0 : _a.fields.forEach((field) => {
                if (field.isAddressLookupField && field.id !== this.field.id) {
                    field.Mutator.isAddressLookupField(false);
                }
            });
        }
        else {
            this.field.getForm().metadata.removeAddressLookupField(this.field);
        }
    }
    adminOnly(adminOnly) {
        this.state.setFieldValue(this.field.fieldId, Object.assign(Object.assign({}, this.field.stateValue), { adminOnly }));
        //Set field as hidden if the field is admin-only
        if (adminOnly) {
            this.field.Mutator.collector(core_api_1.IkeCollectorType.OFFICE);
        }
    }
    collector(collector) {
        this.state.setFieldValue(this.field.fieldId, Object.assign(Object.assign({}, this.field.stateValue), { collector }));
    }
    cloneable(cloneable) {
        this.state.setFieldValue(this.field.fieldId, Object.assign(Object.assign({}, this.field.stateValue), { cloneable }));
    }
    /** Overwrite the list of providers with this list */
    providers(providers) {
        this.state.setFieldValue(this.field.fieldId, Object.assign(Object.assign({}, this.field.stateValue), { providers }));
    }
    /** Toggle a specific provider on or off */
    provider(providerType) {
        var _a;
        const stateValue = this.field.stateValue;
        const providers = array_1.IkeArray.clone((_a = stateValue.providers) !== null && _a !== void 0 ? _a : null);
        const foundIndex = providers.findIndex((f) => f.type === providerType);
        if (foundIndex == null) {
            providers.push({ type: providerType });
        }
        else {
            providers.splice(foundIndex, 1);
        }
        this.state.setFieldValue(this.field.fieldId, Object.assign(Object.assign({}, this.field.stateValue), { providers }));
    }
    /** Move the field up one position in the form */
    moveUp() {
        var _a;
        (_a = this.field.parent) === null || _a === void 0 ? void 0 : _a.Mutator.move(this.field.id, -1);
    }
    /** Move the field up one position in the form */
    moveDown() {
        var _a;
        (_a = this.field.parent) === null || _a === void 0 ? void 0 : _a.Mutator.move(this.field.id, 1);
    }
    delete() {
        var _a;
        (_a = this.field.parent) === null || _a === void 0 ? void 0 : _a.Mutator.remove(this.field.id);
    }
    setLockState(lockState) {
        this.state.setFieldValue(this.field.fieldId, Object.assign(Object.assign({}, this.field.stateValue), { locked: lockState }));
    }
    isGenerated(isGenerated) {
        this.state.setFieldValue(this.field.fieldId, Object.assign(Object.assign({}, this.field.stateValue), { isGenerated: isGenerated }));
    }
}
exports.FormModelMutatorField = FormModelMutatorField;
class FormModelField {
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    get fieldId() {
        if (this.parent == null) {
            return ':' + this.id;
        }
        return this.parent.id + ':' + this.id;
    }
    get Mutator() {
        if (this._Mutator == null) {
            this._Mutator = new FormModelMutatorField(this);
        }
        return this._Mutator;
    }
    constructor(parent, id) {
        this._Mutator = null;
        this._id = id;
        this.parent = parent !== null && parent !== void 0 ? parent : undefined;
        const { metadata } = this.getForm();
        if (metadata && metadata.statusFieldId === id) {
            this.stateValue.isStatusField = true;
        }
        if (metadata && metadata.mapColorFieldId === id) {
            this.stateValue.isMapColorField = true;
        }
        if (metadata && metadata.addressLookupFieldId === id) {
            this.stateValue.isAddressLookupField = true;
        }
    }
    getForm() {
        return this.parent.getForm();
    }
    get displayName() {
        return this.stateValue.displayName;
    }
    get title() {
        return this.stateValue.title;
    }
    get subtitle() {
        return this.stateValue.subtitle;
    }
    get isStatusField() {
        return this.stateValue.isStatusField;
    }
    get isMapColorField() {
        return this.stateValue.isMapColorField;
    }
    get required() {
        return this.stateValue.required;
    }
    get isAddressLookupField() {
        return this.stateValue.isAddressLookupField;
    }
    get adminOnly() {
        return this.stateValue.adminOnly;
    }
    get collector() {
        return this.stateValue.collector;
    }
    get annotationLabelFieldId() {
        return this.stateValue.annotationLabelFieldId;
    }
    get clearanceThresholdInMeters() {
        return this.stateValue.clearanceThresholdInMeters;
    }
    get cloneable() {
        return this.stateValue.cloneable;
    }
    get providers() {
        return this.stateValue.providers;
    }
    get type() {
        return this.stateValue.type;
    }
    get isCloneable() {
        const cloneable = this.stateValue.cloneable;
        return cloneable != null && cloneable !== core_api_1.IkeCloneable.NONE;
    }
    get isRoot() {
        var _a;
        return ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.parent) == null;
    }
    get stateValue() {
        return this.getForm().state.getFieldValue(this.fieldId);
    }
    get isLocked() {
        var _a;
        const lockedState = (_a = this.stateValue) === null || _a === void 0 ? void 0 : _a.locked;
        // If we have locked specifically set to false (instead of undefined), it should override the legacy hard coded fields
        if (lockedState === undefined) {
            return Boolean(form_field_lock_1.LOCKED_MODEL_POLE_FIELDS[this.id]);
        }
        return lockedState;
    }
    get isGenerated() {
        var _a;
        return ((_a = this.stateValue) === null || _a === void 0 ? void 0 : _a.isGenerated) || false;
    }
}
exports.FormModelField = FormModelField;
//# sourceMappingURL=form.field.js.map